import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './UsuarioLogadoPage.css';
import TituloComponent from '../../components/Titulo/TituloComponent';

const UsuarioLogado = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const userData = location.state?.userData; // Dados passados pelo navigate
  const statusUsuario = userData?.statusUsuario;
  const nomePerfil = userData?.dadosPerfil.nome;

  useEffect(() => {

    if (!userData.statusUsuario || statusUsuario !== 'logado') {
      console.log(' !!!! Usuário não logado ou dados ausentes. Redirecionando...');
      navigate('/area-restrita'); // Redireciona para a página de login
    } else {

        // vamos redirecionar o usuáiro de acordo com seu perfil
        if( nomePerfil === 'BAR GERENTE' ){
            console.log('vai redirecionar para página BarGerente');
            navigate('/bar-gerente'); // Redireciona para a página de gerente
        } else if( nomePerfil === 'BAR COZINHA' ){
            console.log('vai redirecionar para página BarCozinha');
            navigate('/bar-cozinha');
        } else if( nomePerfil === 'BAR BARMAN' ){
            console.log('vai redirecionar para página BarBarman');
            navigate('/bar-barman');
        } else if( nomePerfil === 'BAR GARCON' ){
          console.log('vai redirecionar para página BarGarcon');
          navigate('/bar-garcon');
      }

    }
  }, [userData, statusUsuario, nomePerfil, navigate]);

  // Função para deslogar o usuário
  const handleLogout = () => {
    // Limpa os dados da sessão
    // sessionStorage.removeItem('userData');
    // Remove todos os dados da sessão
    sessionStorage.clear();
    // Redireciona para a página de login (ou área restrita)
    navigate('/area-restrita');
  };

  // Se statusUsuario não for 'logado', o usuário não tem permissão
  if (statusUsuario !== 'logado') {
    return (
      <div className="erro-container">
        <h2>Erro: Você não está autorizado a acessar esta página.</h2>
      </div>
    );
  }

  return (
    <div className="usuario-logado-container">
        <TituloComponent />

        <h1 className="sub-titulo">Área do Usuário</h1>
        <div className="usuario-logado-box">
            <p className="usuario-logado-welcome">
            Bem-vindo, {userData?.user?.name || 'Usuário'}! 
            <br></br>
            Status: {userData.statusUsuario} 
            <br></br>
            Perfil: {nomePerfil}
            </p>
            <button className="usuario-logado-btn" onClick={handleLogout}>Logout</button>
        </div>
    </div>
  );
};

export default UsuarioLogado;
